import Image from './_image.js'
import Button from './_button.js'
import Popup from './_popup.js'

export default {
  name: 'SettingsMenuPopup',
  values: {
    icon: {
      configSet: Image,
      configValues: {
        src: 'settings',
        style: {
          flexGrow: 1,
          flexBasis: '16px',
        },
      },
    },
    iconColor: {
      closed: undefined,
      open: undefined,
    },
    button: {
      configSet: Button,
      configValues: {
        style: {
          base: {
            flexGrow: 0,
            flexBasis: '40px',
            padding: '12px 0',
          },
        },
      },
    },
    popup: {
      configSet: Popup,
      configValues: {
        style: {
          zIndex: 700,
        },
        container: {
          style: {
            width: '185px',
            top: '40px',
            right: '2px',
          },
        },
        content: {
          style: {
            base: {
              flexDirection: 'column',
            },
          },
        },
        arrowhead: {
          direction: 'up',
        },
        arrowheadOffset: '-10px',
      },
    },
  },
  meta: {
    extendable: false,
  },
}
